import React, { Component } from 'react';
import { connect } from 'react-redux';

import materialTabService from '../../../../services/requests/material-tab.service';
import { standardList } from '../../../../app.values';
import Spinner from '../../../../components/LoadingStyles/Spinner';
import {
  setRebarInstallationConditions,
  setRebarLongItem,
  setRebarShortItem,
  setRebarTemperature, setRebarUsingOrillingAid, setRebarHoleConditions
} from '@reducers/selectors/material/actions';

import { unitLabel, unitTransform } from '@services/helper.service';
import { defaultUnits } from '@config';

import Input from "@components/Input";
import { APP_TEXTS } from '../../../../texts/texts';

class DrillingAndTemperature extends Component {

  conditions = [];
  holeConditions = [];
  ranges = [];

  constructor(props) {
    super(props);

    this.fetchOptions();

    this.state = {
      isPending: true
    };
  }

  componentDidUpdate(prevProps) {
    if (this.props.designStandard !== prevProps.designStandard){
      Promise.all([
        materialTabService.getRangeTemperature(),
        // materialTabService.getInstallationConditions(),
        // materialTabService.getHoleConditions()
      ])
      .then(([ranges]) => {
        this.ranges = ranges;
        if (!this.props.temperature) {
          this.props.setTemperature(this.ranges[0]['InternalName']);
          var temps = this.ranges[0]['InternalName'].split(';');
          this.props.setShortItem(+temps[0]);
          this.props.setLongItem(+temps[1]);
          this.forceUpdate(); // VladP: The arrays are not part of the state object, so we have to force an update
        }
      }); 
    }
  }

  fetchOptions() {
    Promise.all([
      materialTabService.getRangeTemperature(),
      materialTabService.getInstallationConditions(),
      materialTabService.getHoleConditions()
    ])
      .then(this.handleResponse)
      .then(
        this.unsetPending,
        this.unsetPending
      );
  }

  handleResponse = ([ranges, conditions, holeConditions]) => {
    this.ranges = ranges;
    this.conditions = conditions;
    this.holeConditions = holeConditions;

    if (!this.props.temperature) {
      this.props.setTemperature(this.ranges[0]['InternalName']);
      var temps = this.ranges[0]['InternalName'].split(';');
      this.props.setShortItem(+temps[0]);
      this.props.setLongItem(+temps[1]);
    }
  };

  unsetPending = () => this.setState({ isPending: false });

  render() {
    return (
      <div className="calculation">
        { this.state.isPending && <Spinner /> }

        <section className="list-type">
          <h4>{APP_TEXTS.TEMPERATURE.Content}</h4>
          <select
            className="form-control w-75"
            name="chosenRange"
            value={this.props.temperature}
            onChange={e => {
              this.props.setTemperature(e.target.value);
              var temps = e.target.value.split(';');
              this.props.setShortItem(+temps[0]);
              this.props.setLongItem(+temps[1]);
            }}
          >
            {this.ranges && this.ranges.map(n => (
              <option value={n['InternalName']} key={n['InternalName']}>{n['RunName']}</option>
            ))}
          </select>

          <div className="mt-4">
            <Input
                id="longItem"
              prefix={APP_TEXTS.DRILLING_AND_TEMPERATURE_LONG_ITEM_LABEL.Content+'\xa0'} //"Long item:&nbsp;"
              postfix={unitLabel(this.props.temperatureUnit)}
                type="number"
              className="stand-off__label"
              value={unitTransform(+this.props.longItem).from(defaultUnits.TEMPERATURE).to(this.props.temperatureUnit)}
              onUpdate={value => {
                this.props.setLongItem(unitTransform(+value, false).from(this.props.temperatureUnit).to(defaultUnits.TEMPERATURE));
              }}
              disabled
              />
          </div>

          <div>
            <Input
              id="shortItem"
              prefix={APP_TEXTS.DRILLING_AND_TEMPERATURE_SHORT_ITEM_LABEL.Content+'\xa0'} //"Short item:&nbsp;"
              postfix={unitLabel(this.props.temperatureUnit)}
                type="number"
              className="stand-off__label"
              value={unitTransform(+this.props.shortItem).from(defaultUnits.TEMPERATURE).to(this.props.temperatureUnit)}
              onUpdate={value => {
                this.props.setShortItem(unitTransform(+value, false).from(this.props.temperatureUnit).to(defaultUnits.TEMPERATURE));
              }}
              disabled
              />
          </div>

          <h4 className="reinforcement__title mt-5">{APP_TEXTS.MATERIAL_LABEL_INSTALLATION_CONDITIONS.Content}</h4>
          {this.isAnzStandart && (
            <select
              name="chosenHoleCondition"
              className="form-control w-75"
              value={this.props.holeConditions}
              onChange={e => this.props.setHoleConditions(e.target.value)}
            >
              {this.holeConditions && this.holeConditions.map(n => (
                <option value={n['InternalName']} key={n['InternalName']}>{n['RunName']}</option>
              ))}
            </select>
          )}

          <select
            className="form-control w-75"
            name="chosenCondition"
            value={this.props.installationConditions}
            onChange={e => this.props.setInstallationConditions(e.target.value)}
          >
            {this.conditions && this.conditions.map(n => (
              <option value={n['InternalName']} key={n['InternalName']}>{n['RunName']}</option>
            ))}
          </select>

          {!this.isAnzStandart && (
            <React.Fragment>
              <br/>
              <div className="custom-control custom-checkbox mt-3">
                <input
                  type="checkbox"
                  className="custom-control-input"
                  id="drilling"
                  onChange={e => this.props.setUsingOrillingAid(e.target.checked)}
                  checked={this.props.usingDrillingAid}
                />
                <label className="custom-control-label" htmlFor="drilling">            
                {APP_TEXTS.USING_DRILLING_AID.Content}             
                </label>
              </div>
            </React.Fragment>
          )}
        </section>
      </div>
    );
  }

  get isAnzStandart () {
    return (
      Number(this.props.designStandard) === standardList['ANZ'] ||
      Number(this.props.designStandard) === standardList['AS5216'] ||
      Number(this.props.designStandard) === standardList['AS3600'] 
    );
  }

}

const mapState = state => ({
  designStandard: state.main.localization.designStandard,

  temperature: state.selectors.material[state.main.appType].drillingAndTemperature.temperature,
  longItem: state.selectors.material[state.main.appType].drillingAndTemperature.longItem,
  shortItem: state.selectors.material[state.main.appType].drillingAndTemperature.shortItem,
  installationConditions: state.selectors.material[state.main.appType].drillingAndTemperature.installationConditions,
  holeConditions: state.selectors.material[state.main.appType].drillingAndTemperature.holeConditions,
  usingDrillingAid: state.selectors.material[state.main.appType].drillingAndTemperature.usingDrillingAid,

  temperatureUnit: state.main.units.temperature
});

const mapDispatch = dispatch => ({
  setTemperature: value => dispatch(setRebarTemperature(value)),
  setLongItem: value => dispatch(setRebarLongItem(value)),
  setShortItem: value => dispatch(setRebarShortItem(value)),
  setInstallationConditions: value => dispatch(setRebarInstallationConditions(value)),
  setUsingOrillingAid: value => dispatch(setRebarUsingOrillingAid(value)),
  setHoleConditions: value => dispatch(setRebarHoleConditions(value))
});

export default connect(mapState, mapDispatch)(DrillingAndTemperature);



// WEBPACK FOOTER //
// ./src/views/Material/components/DrillingAndTemperature/index.js